<template>
  <div :class="edgeMaskEnabled ? 'scroller-mask' : ''" class="scroller" ref="scroller">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Scroller',
  props: {
    scrollToIndex: {
      type: Number,
      default: 0,
    },
    edgeMaskEnabled: {
      type: Boolean,
      default: true,
    }
  },
  beforeDestroy() {
    this.$refs.scroller.removeEventListener('scroll', this.onScroll);
  },
  mounted() {
    this.$refs.scroller.addEventListener('scroll', this.onScroll);
    this.onScroll({ currentTarget: this.$refs.scroller });
    if (this.scrollToIndex > -1) this.scrollTo(this.scrollToIndex);
  },
  methods: {
    scrollTo(index) {
      const { scroller } = this.$refs;
      const y = scroller.children[index].offsetTop - scroller.offsetTop - scroller.clientHeight / 2;
      scroller.scrollTo(0, y, true);
    },
    onScroll(e) {
      const el = e.currentTarget;
      const isScrollable = el.scrollHeight > el.clientHeight;

      // GUARD: If element is not scrollable, remove all classes
      if (!isScrollable) {
        el.classList.remove('is-bottom-overflowing', 'is-top-overflowing');
        return;
      }

      const isScrolledToBottom = el.scrollHeight < el.clientHeight + el.scrollTop + 1;
      const isScrolledToTop = isScrolledToBottom ? false : el.scrollTop <= 0;
      el.classList.toggle('is-bottom-overflowing', !isScrolledToBottom);
      el.classList.toggle('is-top-overflowing', !isScrolledToTop);
    },
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  overflow-y: auto;
  scroll-behavior: smooth;
}

.scroller-mask {
  -webkit-mask-image: linear-gradient(to bottom, transparent 0, black var(--top-mask-size, 0), black calc(100% - var(--bottom-mask-size, 0)), transparent 100%);
  mask-image: linear-gradient(to bottom, transparent 0, black var(--top-mask-size, 0), black calc(100% - var(--bottom-mask-size, 0)), transparent 100%);
  --top-mask-size: 0px;
  --bottom-mask-size: 0px;
}

.scroller::-webkit-scrollbar {
  display: none;
}

.scroller.is-top-overflowing {
  --top-mask-size: 10% !important;
}

.scroller.is-bottom-overflowing {
  --bottom-mask-size: 10% !important;
}
</style>
